import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AppSettingsService } from '../../../app-settings.service';
import { Enums } from '../../../../../configs/Enums';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-general-settings',
  templateUrl: './general-settings.component.html',
  styleUrls: ['./general-settings.component.scss'],
  standalone: false,
})
export class GeneralSettingsComponent implements OnInit {
  public loading = false;
  public inactivityDaysTreshold: string | number;
  public generalSettingsError: string | null;
  public generalSettingsSuccess: string | null;
  public qkResponsesTimeout = null;

  @Input() settings: any;

  constructor(private appSettingsService: AppSettingsService) {}

  ngOnInit() {
    this.makeSettings();
  }

  makeSettings() {
    this.inactivityDaysTreshold = this.settings.inactivity_days_treshold;
    this.qkResponsesTimeout = this.settings.qk_responses_timeout;
  }

  onSaveGeneralSettings() {
    this.generalSettingsSuccess = null;
    this.generalSettingsError = null;
    this.loading = true;

    this.appSettingsService
      .updateSettings({
        inactivity_days_treshold: +this.inactivityDaysTreshold,
        qk_responses_timeout: +this.qkResponsesTimeout,
      })
      .subscribe(
        (response) => {
          this.generalSettingsSuccess = 'Настройки успешно сохранены.';
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.generalSettingsError = Enums.errorCodes[Enums.errorCodesMaps['BACKEND_ERROR']];
        }
      );
  }
}
